import { Grid } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import claimManagementStyles from "../../Styles/claimManagement";

const CompOffProcessTable = ({
    clickSubmitHandler,
    salesTeamDataList,
    handleCheckBoxClick,
    handleAttendanceChange,
    allChecked,
    handleAllCheckedClick,
    handleCheckBoxClickForSelectionRowData,
}) => {
    const [searchValue, setSeachValue] = React.useState("");

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue);
    };

    const getFilteredTableData = (tableData) => {
        return tableData.filter((currentRow) => {
            let isValid = false;
            let date =
                currentRow.date != null ? currentRow.date : "";
            if (
                date &&
                date.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    return (
        <>
            {salesTeamDataList.length !== 0 && (
                <>
                    <LandingScreenHeader
                        screenTitle={""}
                        showSearchBox={true}
                        showTable={true}
                        showFilter={false}
                        showPdfDownload={false}
                        showExcelDownload={false}
                        onSearch={onSearchValue}
                    />

                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: "500px",
                            position: "relative",
                        }}
                    >
                        <table
                            style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            <thead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#03a9f4",
                                    zIndex: 3,
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <tr>
                                    <th
                                        style={{
                                            ...claimManagementStyles.tableHeadStyle,
                                            minWidth: "60px",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={allChecked}
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                                cursor: "pointer",
                                                accentColor: allChecked ? "#f44336" : "#03a9f4"
                                            }}
                                            onChange={handleAllCheckedClick}
                                        />
                                    </th>
                                    <th
                                        style={{
                                            ...claimManagementStyles.tableHeadStyle,
                                            minWidth: "100px",
                                        }}
                                    >
                                        Sr. No
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "200px", }}>
                                        Date
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, maxWidth: "890px", }}>
                                        Attendance Status
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "190px", }}>
                                        Is Mark As Comp Off ?
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {getFilteredTableData(salesTeamDataList).map((dataObj, index) => (
                                    <tr key={dataObj.id}>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "center",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                style={{
                                                    transform: "scale(1.5)",
                                                    margin: "0 8px",
                                                }}
                                                checked={dataObj.isChecked}
                                                onChange={(e) =>
                                                    handleCheckBoxClickForSelectionRowData(e, dataObj.id)
                                                }
                                            />
                                        </td>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "center",
                                            }}
                                        >
                                            {dataObj.index !== null ? dataObj.index : ""}
                                        </td>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "center",
                                            }}
                                        >
                                            {dataObj.date !== null ? dataObj.date : ""}
                                        </td>

                                        <td style={{
                                            ...claimManagementStyles.cellStyle,
                                            textAlign: "left",
                                            padding: "10px",
                                            maxWidth: "870px",
                                        }}>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                {/* First Row - 5 items */}
                                                <div style={{ display: "flex", gap: "15px" }}>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "120px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: "scale(1.2)" }}
                                                            checked={dataObj.attendance == 0}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 0)}
                                                        />
                                                        Present
                                                    </label>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "120px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: "scale(1.2)" }}
                                                            checked={dataObj.attendance == 1}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 1)}
                                                        />
                                                        Absent
                                                    </label>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "120px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: "scale(1.2)" }}
                                                            checked={dataObj.attendance == 2}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 2)}
                                                        />
                                                        Holiday
                                                    </label>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "120px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: "scale(1.2)" }}
                                                            checked={dataObj.attendance == 3}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 3)}
                                                        />
                                                        Weekly Off
                                                    </label>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "120px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{
                                                                transform: "scale(1.2)",
                                                                accentColor: dataObj.attendance == 4 ? "#2563eb" : undefined,
                                                                cursor: dataObj.attendance == 4 ? "not-allowed" : "pointer"
                                                            }}
                                                            checked={dataObj.attendance == 4}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 4)}
                                                        />
                                                        Leave
                                                    </label>
                                                </div>

                                                {/* Second Row - 4 items */}
                                                <div style={{ display: "flex", gap: "15px" }}>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "180px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: "scale(1.2)" }}
                                                            checked={dataObj.attendance == 5}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 5)}
                                                        />
                                                        Present + Holiday
                                                    </label>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "200px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: "scale(1.2)" }}
                                                            checked={dataObj.attendance == 6}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 6)}
                                                        />
                                                        Present + Weekly Off
                                                    </label>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "270px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: "scale(1.2)" }}
                                                            checked={dataObj.attendance == 7}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 7)}
                                                        />
                                                        Present + Weekly Off + Holiday
                                                    </label>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "5px", width: "180px" }}>
                                                        <input
                                                            type="checkbox"
                                                            style={{ transform: "scale(1.2)" }}
                                                            checked={dataObj.attendance == 8}
                                                            disabled={dataObj.attendanceForLeave == 4}
                                                            onChange={() => handleAttendanceChange(dataObj.id, 8)}
                                                        />
                                                        Present + Leave
                                                    </label>
                                                </div>
                                            </div>
                                        </td>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "center",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                style={{
                                                    transform: "scale(1.5)",
                                                    margin: "0 8px",
                                                    cursor: dataObj.attendance == 0 || dataObj.attendance == 1 ||
                                                        dataObj.attendance == 2 || dataObj.attendance == 3 ||
                                                        dataObj.attendance == 4 ? "not-allowed" : "pointer"
                                                }}
                                                checked={dataObj.isMarkCompOff}
                                                disabled={dataObj.attendance == 0 || dataObj.attendance == 1 ||
                                                    dataObj.attendance == 2 || dataObj.attendance == 3 ||
                                                    dataObj.attendance == 4
                                                }
                                                onChange={(e) => handleCheckBoxClick(e, dataObj.id)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <br />
                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="flex-end"
                        gap={2}
                    >
                        <ButtonCompo
                            sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                            }}
                            size="medium"
                            type="button"
                            variant="contained"
                            name={"Submit"}
                            onClick={clickSubmitHandler}
                            fullWidth={false}
                        />
                    </Grid>
                </>
            )}
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompOffProcessTable);
